import { render, staticRenderFns } from "./Scrapbook.vue?vue&type=template&id=46c94d30&scoped=true&"
import script from "./Scrapbook.vue?vue&type=script&lang=js&"
export * from "./Scrapbook.vue?vue&type=script&lang=js&"
import style0 from "./Scrapbook.vue?vue&type=style&index=0&id=46c94d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c94d30",
  null
  
)

export default component.exports